export const MONEY_FORMAT = 'money'
